import React from 'react';
import styled from 'styled-components';
import { Popup, Button, BentoProvider } from '@prezi/bento';
import { white } from '@prezi/common-design';
import { Typography } from '@prezi/common-components';
const PopupInner = styled.div.withConfig({
  displayName: "Tooltip__PopupInner",
  componentId: "sc-49jhke-0"
})(["padding:16px;max-width:350px;"]);
const PopupTitle = styled(Typography).withConfig({
  displayName: "Tooltip__PopupTitle",
  componentId: "sc-49jhke-1"
})(["color:#dfab29;white-space:nowrap;font-size:14px;line-height:20px;margin-bottom:8px;"]);
const PopupBody = styled(Typography).withConfig({
  displayName: "Tooltip__PopupBody",
  componentId: "sc-49jhke-2"
})(["color:", ";font-size:12px;line-height:16px;"], white);
export const Tooltip = ({
  isOpen,
  onClose,
  triggerRef,
  uxCopy,
  onAction
}) => {
  const [isHoveringItself, setIsHoveringItself] = React.useState(false);
  return React.createElement(BentoProvider, {
    mode: "dark"
  }, React.createElement(Popup, {
    isOpen: isOpen || isHoveringItself,
    onClose: onClose,
    parentRef: triggerRef,
    arrowSize: 6,
    hasShadow: false,
    placement: "bottom"
  }, React.createElement(PopupInner, {
    onMouseEnter: () => setIsHoveringItself(true),
    onMouseLeave: () => setIsHoveringItself(false)
  }, React.createElement(PopupTitle, {
    type: "p"
  }, uxCopy.title), React.createElement(PopupBody, {
    type: "p"
  }, uxCopy.body), onAction && React.createElement(Button, {
    variant: "primary",
    onClick: onAction,
    style: {
      background: '#dfab29',
      borderColor: '#dfab29'
    }
  }, uxCopy.action))));
};